module.exports = __webpack_public_path__ + "img/car_shina2_14.20aa7d81.jpg";